import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { BaseUrl } from "../../../Helper/BaseUrl";
import { toastErrorr, toastSuccesss } from "../../../Helper/ToastMessage";


// Get Table Data
export const STPEnergyConsumptionTableDataAPI = createAsyncThunk("STPEnergyConsumptionTableData", async ({ data }) => {
    const {
        M_IndicatorSTPEnergyID,
        FromDate,
        ToDate,
        M_WardID,
        M_UserID,
        Flag,
        token,
        From,
        To,
        STPPreventiveEnergyExport
    } = data

    var myHeaders = new Headers();
    myHeaders.append("Authorization", "Bearer " + token);

    var requestOptions = {
        method: 'GET',
        headers: myHeaders,
        redirect: 'follow'
    };

    return fetch(`${BaseUrl}/APKDashboard/Get_WEB_STP_T_STP_EnergyConsumption_Select?M_WardID=${M_WardID ? M_WardID : '0'}&FromDate=${FromDate ? FromDate : ''}&ToDate=${ToDate ? ToDate : ''}&M_IndicatorSTPEnergyID=${M_IndicatorSTPEnergyID ? M_IndicatorSTPEnergyID : '0'}&M_UserID=${M_UserID}&From=${From}&To=${To}&Flag=${Flag}`, requestOptions)
        .then((res) => res.json())
        .then((result) => {
            // console.log(result.data1, result.data) 
            if (result.code >= 200 && result.code <= 300 && result.data && result.data.table) {
                STPPreventiveEnergyExport()
                return result.data

            } else {
                return result
            }
        })
})

const STPEnergyConsumptionTableDataSlice = createSlice({
    name: "STPEnergyConsumptionTableData",
    initialState: {
        isLoading: false,
        tableData: null,
        isError: false,
    },
    extraReducers: (builder) => {
        builder.addCase(STPEnergyConsumptionTableDataAPI.pending, (state, action) => {
            state.isLoading = true;
        });
        builder.addCase(STPEnergyConsumptionTableDataAPI.fulfilled, (state, action) => {
            state.isLoading = false;
            state.tableData = action.payload;
        });
        builder.addCase(STPEnergyConsumptionTableDataAPI.rejected, (state, action) => {
            console.log("Error", action.payload);
            state.isLoading = false;
            state.isError = true;
            state.tableData = null;
            toastErrorr('Something went wrong')
        });
    },
})

export const STPEnergyConsumptionTableDataReducer = STPEnergyConsumptionTableDataSlice.reducer

export const STPEnergyConsumptionTableExportDataAPI = createAsyncThunk("STPEnergyConsumptionTableExportData", async ({ data }) => {
    const {
        M_IndicatorSTPEnergyID,
        FromDate,
        ToDate,
        M_WardID,
        M_UserID,
        Flag,
        token,
        From,
        To,
    } = data

    var myHeaders = new Headers();
    myHeaders.append("Authorization", "Bearer " + token);

    var requestOptions = {
        method: 'GET',
        headers: myHeaders,
        redirect: 'follow'
    };

    return fetch(`${BaseUrl}/APKDashboard/Get_WEB_STP_T_STP_EnergyConsumption_Select?M_WardID=${M_WardID ? M_WardID : '0'}&FromDate=${FromDate ? FromDate : ''}&ToDate=${ToDate ? ToDate : ''}&M_IndicatorSTPEnergyID=${M_IndicatorSTPEnergyID ? M_IndicatorSTPEnergyID : '0'}&M_UserID=${M_UserID}&From=${From}&To=${To}&Flag=${Flag}`, requestOptions)
        .then((res) => res.json())
        .then((result) => {
            // console.log(result.data1, result.data) 
            if (result.code >= 200 && result.code <= 300 && result.data) {
                return result.data

            } else {
                return result
            }
        })
})

const STPEnergyConsumptionTableExportDataSlice = createSlice({
    name: "STPEnergyConsumptionTableExportData",
    initialState: {
        isExportLoading: false,
        ExportTableData: null,
        isError: false,
    },
    extraReducers: (builder) => {
        builder.addCase(STPEnergyConsumptionTableExportDataAPI.pending, (state, action) => {
            state.isExportLoading = true;
        });
        builder.addCase(STPEnergyConsumptionTableExportDataAPI.fulfilled, (state, action) => {
            state.isExportLoading = false;
            state.ExportTableData = action.payload;
        });
        builder.addCase(STPEnergyConsumptionTableExportDataAPI.rejected, (state, action) => {
            console.log("Error", action.payload);
            state.isExportLoading = false;
            state.isError = true;
            state.ExportTableData = null;
            toastErrorr('Something went wrong')
        });
    },
})

export const STPEnergyConsumptionTableExportDataReducer = STPEnergyConsumptionTableExportDataSlice.reducer



export const STPEnergyConsumptionPostDataAPI = createAsyncThunk("STPEnergyConsumptionPostData", async ({ data }) => {
    const {
        T_STP_EnergyConsumptionID,
        TodayReading,
        DieselConsumtion,
        M_UserID,
        token,
        Flag,
        handleIsPost,
        handleOnCloseClick,

    } = data

    var myHeaders = new Headers();
    myHeaders.append("Authorization", "Bearer " + token);

    var formdata = new FormData();

    formdata.append("T_STP_EnergyConsumptionID", T_STP_EnergyConsumptionID);
    formdata.append("TodayReading", TodayReading);
    formdata.append("DieselConsumtion", DieselConsumtion);
    formdata.append("M_UserID", M_UserID);

    var requestOptions = {
        method: 'PATCH',
        headers: myHeaders,
        body: formdata,
        redirect: 'follow'
    };

    fetch(`${BaseUrl}/APKDashboard/Post_WEB_STP_T_STP_EnergyConsumption_Update`, requestOptions)
        .then((res) => res.json())
        .then((result) => {
            if (result.code >= 200 && result.code <= 300 && result.data) {
                handleIsPost()
                // handleClearField()
                handleOnCloseClick()
                toastSuccesss(result.message)
                return result.data
            } else {
                toastErrorr(result.message)
            }
            return result
        })
})

const STPEnergyConsumptionPostDataSlice = createSlice({
    name: "STPEnergyConsumptionPostData",
    initialState: {
        isLoading: false,
        tableData: null,
        isError: false,
    },
    extraReducers: (builder) => {
        builder.addCase(STPEnergyConsumptionPostDataAPI.pending, (state, action) => {
            state.isLoading = true;
        });
        builder.addCase(STPEnergyConsumptionPostDataAPI.fulfilled, (state, action) => {
            state.isLoading = false;
            state.tableData = action.payload;
        });
        builder.addCase(STPEnergyConsumptionPostDataAPI.rejected, (state, action) => {
            console.log("Error", action.payload);
            state.isLoading = false;
            state.isError = true;
            state.tableData = null;
            // toastErrorr('Something went wrong')
        });
    },
})

export const STPEnergyConsumptionPostDataReducer = STPEnergyConsumptionPostDataSlice.reducer

// -----------------Delete API ---------------

export const STPEnergyConsumptionDeleteAPI = createAsyncThunk("STPEnergyConsumptionDelete", async ({ data }) => {
    const {
        T_STP_EnergyConsumptionID,
        M_UserID,
        token,
        handleIsPost
    } = data

    var myHeaders = new Headers();
    myHeaders.append("Authorization", "Bearer " + token);


    var formdata = new FormData();
    formdata.append("T_STP_EnergyConsumptionID", T_STP_EnergyConsumptionID);
    formdata.append("M_UserID", M_UserID);

    var requestOptions = {
        method: 'DELETE',
        headers: myHeaders,
        body: formdata,
        redirect: 'follow'
    };

    fetch(`${BaseUrl}/APKDashboard/WEB_STP_T_STP_EnergyConsumption_Delete`, requestOptions)
        .then((res) => res.json())
        .then((result) => {
            if (result.status) {
                handleIsPost()
                toastSuccesss(result.message)
            } else {
                toastErrorr(result.message)

            }
            return result

        })
})

const STPEnergyConsumptionDeleteSlice = createSlice({
    name: "STPEnergyConsumptionDelete",
    initialState: {
        isDeleteLoading: false,
        SectorData: null,
        isError: false,
    },
    extraReducers: (builder) => {
        builder.addCase(STPEnergyConsumptionDeleteAPI.pending, (state, action) => {
            state.isDeleteLoading = true;
        });
        builder.addCase(STPEnergyConsumptionDeleteAPI.fulfilled, (state, action) => {
            state.isDeleteLoading = false;
            state.SectorData = action.payload;

        });
        builder.addCase(STPEnergyConsumptionDeleteAPI.rejected, (state, action) => {
            console.log("Error", action.payload);
            state.isDeleteLoading = false;
            state.isError = true;
            state.SectorData = null;
            // toastErrorr('Something went wrong')
        });
    },
})

export const STPEnergyConsumptionDeleteReducer = STPEnergyConsumptionDeleteSlice.reducer